import { createAction } from 'redux-actions';

import types from './types';

const setLoading = createAction(types.SET_LOADING);
const loadAllWishlists = createAction(types.LOAD_WISHLISTS);
const setWishlists = createAction(types.SET_WISHLISTS);
const moveToWishlist = createAction(types.MOVE_TO_WISHLIST);
const clearWishlists = createAction(types.CLEAR_WISHLISTS);

export default {
    setLoading,
    loadAllWishlists,
    setWishlists,
    moveToWishlist,
    clearWishlists,
};
